import classNames from "classnames";
import { ViewCard } from "~/common/components/card/ViewCard";
import { ViewCardWide } from "~/common/components/card/ViewCardWide";
import { ImageData } from "~/models/image";
import { unEntity } from "~/utils/dom";
import { CardItemImage } from "./CardItemImage";

export type CardItemLabel = {
  text: string;
  color: string;
  backgroundColor: string;
};

export function CardItem(props: {
  title?: string;
  image?: ImageData;
  link: string;
  description?: string;
  focalPoint?: { x: number; y: number };
  width: string;
  label?: CardItemLabel;
}) {
  const image = props.image
    ? { src: props.image.url, alt: props.image.alt || "" }
    : undefined;

  const objectPosition = `${
    props?.focalPoint?.x ? props.focalPoint.x * 100 : 100
  }% ${props?.focalPoint?.y ? props.focalPoint.y * 100 : 100}%`;

  const imageComponent = (
    <CardItemImage
      image={image}
      imagePosition={objectPosition}
      label={props.label}
    />
  );

  const title = props.title ? unEntity(props.title) : "";
  const description = props.description ?? "";

  return (
    <div
      className={classNames(
        "cn-container-class tw:h-full",
        props.width === "double"
          ? "cn-column-double"
          : props.width === "full"
          ? "cn-column-full"
          : "",
      )}
    >
      <a
        href={props.link}
        className="tw:!no-underline tw:text-inherit tw:focus:!outline-none"
      >
        {props.width === "single" ? (
          <ViewCard
            imageComponent={imageComponent}
            title={title}
            description={description}
          />
        ) : (
          <ViewCardWide
            imageComponent={imageComponent}
            title={title}
            description={description}
            largeImageSize={props.width === "double" ? true : false}
          />
        )}
      </a>
    </div>
  );
}
